import { render, staticRenderFns } from "./TenantCreateDialog.vue?vue&type=template&id=048b8eb4&scoped=true"
import script from "./TenantCreateDialog.vue?vue&type=script&lang=ts"
export * from "./TenantCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b8eb4",
  null
  
)

export default component.exports